/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  storeLocator: {
    name: 'store-locator',
    componentName: 'StoreLocatorContainer',
    chunk: () => import(
      /* webpackChunkName: "store-locator" */
      './pages/store-locator/StoreLocatorContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-locator/StoreLocatorContainer.js')).StoreLocatorContainer
        : currentRouteName === 'store-locator'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StoreLocatorContainer }))
          );
    },
    path: '/:context?/l/store-locator',
    varnish: true,
    channel: 'desktop'
  },

  storeLocatorMobile: {
    name: 'store-locator-mobile',
    componentName: 'StoreLocatorMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "store-locator-mobile" */
      './pages/store-locator/StoreLocatorMobileContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-locator/StoreLocatorMobileContainer.js')).StoreLocatorMobileContainer
        : currentRouteName === 'store-locator-mobile'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StoreLocatorMobileContainer }))
          );
    },
    path: '/:context?/l/store-locator',
    varnish: true,
    channel: 'mobile'
  },

  homeServices: {
    name: 'homeservices',
    componentName: 'HomeServicesContainer',
    chunk: () => import(
      /* webpackChunkName: "homeservices" */
      './pages/home-services/HomeServicesContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/home-services/HomeServicesContainer.js')).HomeServicesContainer
        : currentRouteName === 'homeservices'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.HomeServicesContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/services',
    varnish: true,
    channel: null
  },

  rentalServices: {
    name: 'rentalservices',
    componentName: 'RentalServicesContainer',
    chunk: () => import(
      /* webpackChunkName: "rentalservices" */
      './pages/rental-services/RentalServicesContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/rental-services/RentalServicesContainer.js')).RentalServicesContainer
        : currentRouteName === 'rentalservices'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.RentalServicesContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/rentals',
    varnish: true,
    channel: null
  },

  gardenCenter: {
    name: 'gardencenter',
    componentName: 'GardenCenterContainer',
    chunk: () => import(
      /* webpackChunkName: "gardencenter" */
      './pages/garden-center/GardenCenterContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/garden-center/GardenCenterContainer.js')).GardenCenterContainer
        : currentRouteName === 'gardenCenter'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.GardenCenterContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/garden-center',
    varnish: true,
    channel: null
  },

  proDesk: {
    name: 'proDesk',
    componentName: 'ProDeskContainer',
    chunk: () => import(
      /* webpackChunkName: "proDesk" */
      './pages/pro-desk/ProDeskContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pro-desk/ProDeskContainer.js')).ProDeskContainer
        : currentRouteName === 'pro-desk'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProDeskContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/pro-desk',
    varnish: true,
    channel: null
  },

  storeReviews: {
    name: 'store-reviews',
    componentName: 'ReviewsContainer',
    chunk: () => import(
      /* webpackChunkName: "store-reviews" */
      './pages/store-reviews/ReviewsContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-reviews/ReviewsContainer.js')).ReviewsContainer
        : currentRouteName === 'storereviews'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ReviewsContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/reviews/:reviewPage?',
    varnish: true,
    channel: null
  },

  storeDetails: {
    name: 'store-details',
    componentName: 'DetailsContainer',
    chunk: () => import(
      /* webpackChunkName: "store-details" */
      './pages/store-details/DetailsContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-details/DetailsContainer.js')).DetailsContainer
        : currentRouteName === 'storedetails'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DetailsContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber',
    varnish: true,
    channel: null
  },

  storeDirectory: {
    name: 'store-directory',
    componentName: 'DirectoryContainer',
    chunk: () => import(
      /* webpackChunkName: "store-directory" */
      './pages/store-directory/DirectoryContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-directory/DirectoryContainer.js')).DirectoryContainer
        : currentRouteName === 'storedirectory'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DirectoryContainer })))
    },
    path: '/:context?/l/storeDirectory',
    varnish: true,
    channel: null
  },

  localCity: {
    name: 'local-city',
    componentName: 'LocalCityContainer',
    chunk: () => import(
      /* webpackChunkName: "local-city" */
      './pages/local-city/LocalCityContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/local-city/LocalCityContainer.js')).LocalCityContainer
        : currentRouteName === 'localcity'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.LocalCityContainer })))
    },
    path: '/:context?/l/:state/:city/:guid',
    varnish: true,
    channel: null
  },

  stateDirectory: {
    name: 'state-directory',
    componentName: 'StateDirectoryContainer',
    chunk: () => import(
      /* webpackChunkName: "state-directory" */
      './pages/store-directory/StateDirectoryContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-directory/StateDirectoryContainer.js')).StateDirectoryContainer
        : currentRouteName === 'statedirectory'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StateDirectoryContainer })))
    },
    path: '/:context?/l/:state',
    varnish: true,
    channel: null
  },
});
